import React from 'react';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { getContext } from '@fiverr-private/fiverr_context';
import { LeafCategoryTile } from '../tiles/leafCategoryTile/leafCategoryTile';
import { TilesCarousel } from '../tiles_carousel/tilesCarousel';
import { buildEventEnrichment } from '../../generic_listings/TagFilters/utils';
import { VIEW_ALL_COMPONENT } from '../top_filters_carousel/topFiltersCarousel.constants';
import { BI_ELEMENTS_NAMES, BI_EVENTS_TYPES, ELEMENT_TYPE } from '../../generic_listings/TagFilters/constants';
import { BI_EVENT_GROUPS } from '../../../../../shared/services/BIEvents/constants';
import {
    MAX_TILES_TO_SHOW,
    MINIMUM_TILES_LENGTH,
    MOBILE_SLIDE_PADDING,
    SLIDE_PADDING,
} from '../tiles_carousel/constants';
import type { LeafCategoriesCarouselProps } from './leafCategoriesCarousel.types';
import { LeafCategoriesCarouselTitle } from './leafCategoriesCarouselTitle';

import './index.scss';

export const LeafCategoriesCarousel: React.FC<LeafCategoriesCarouselProps> = ({ leafCategoryTiles = [], query }) => {
    const { isTouch } = getContext();
    const enrichment = buildEventEnrichment({
        type: BI_EVENTS_TYPES.IMPRESSION,
        group: BI_EVENT_GROUPS.USER_IMPRESSION,
        elementName: BI_ELEMENTS_NAMES.LEAF_CATEGORY,
        elementType: ELEMENT_TYPE.VISUAL,
        elementMetadata: null,
        componentName: null,
        elementPosition: null,
    });
    const [ref] = useImpressionItem({ enrichment });

    if (leafCategoryTiles.length < MINIMUM_TILES_LENGTH) {
        return null;
    }

    const tilesWithViewAll = [...leafCategoryTiles, { id: VIEW_ALL_COMPONENT }];

    return (
        <div ref={ref} className="sc-carousel">
            <LeafCategoriesCarouselTitle query={query} />
            <div className="sc-carousel-wrapper">
                <TilesCarousel
                    items={tilesWithViewAll}
                    TileComponent={LeafCategoryTile}
                    tilePadding={isTouch ? MOBILE_SLIDE_PADDING : SLIDE_PADDING}
                    maxTilesToShow={MAX_TILES_TO_SHOW}
                />
            </div>
        </div>
    );
};
